import {createAction} from '@ngrx/store';

// Empty action which does nothing, Ref - https://intertech.medium.com/ngrx-effects-a-case-for-returning-a-no-op-action-3e195cc6d2dd
export const NoOpAction = createAction(
  '[NoOp] No-Op Action'
);
